export function trimBlurValue(value: string): string {
  return String(value || "").trim();
}

export function toTitleCaseTr(value: string): string {
  return String(value || "")
    .trim()
    .toLocaleLowerCase("tr-TR")
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toLocaleUpperCase("tr-TR") + part.slice(1))
    .join(" ");
}

export function normalizeEmail(value: string): string {
  return String(value || "")
    .trim()
    .toLowerCase();
}

export function digitsOnly(value: string, maxLength?: number): string {
  const digits = String(value || "").replace(/\D/g, "");
  return maxLength ? digits.slice(0, maxLength) : digits;
}

export function formatTurkishPhoneInput(value: string): string {
  const digits = digitsOnly(value, 11);
  if (!digits) return "";

  let local = digits;
  if (digits.startsWith("90") && digits.length >= 12) {
    local = `0${digits.slice(2, 12)}`;
  } else if (!digits.startsWith("0") && digits.length <= 10) {
    local = `0${digits}`;
  }

  const trimmed = local.slice(0, 11);
  if (trimmed.length <= 4) return trimmed;
  if (trimmed.length <= 7) return `${trimmed.slice(0, 4)} ${trimmed.slice(4)}`;
  if (trimmed.length <= 9) {
    return `${trimmed.slice(0, 4)} ${trimmed.slice(4, 7)} ${trimmed.slice(7)}`;
  }
  return `${trimmed.slice(0, 4)} ${trimmed.slice(4, 7)} ${trimmed.slice(7, 9)} ${trimmed.slice(9, 11)}`;
}

export function formatIbanInput(value: string): string {
  const normalized = String(value || "")
    .replace(/\s/g, "")
    .toUpperCase()
    .slice(0, 34);

  return normalized.replace(/(.{4})/g, "$1 ").trim();
}
